/** Open Food Facts country slugs → display name + emoji flag. */

const SLUG_TO_ISO = {
  "belgium": "BE", "netherlands": "NL", "france": "FR", "germany": "DE",
  "united-kingdom": "GB", "united-states": "US", "spain": "ES", "italy": "IT",
  "switzerland": "CH", "luxembourg": "LU", "austria": "AT", "ireland": "IE",
  "portugal": "PT", "poland": "PL", "sweden": "SE", "denmark": "DK",
  "norway": "NO", "finland": "FI", "canada": "CA", "australia": "AU",
  "new-zealand": "NZ", "mexico": "MX", "brazil": "BR", "argentina": "AR",
  "japan": "JP", "china": "CN", "india": "IN", "thailand": "TH",
  "vietnam": "VN", "indonesia": "ID", "malaysia": "MY", "singapore": "SG",
  "south-korea": "KR", "philippines": "PH", "morocco": "MA", "algeria": "DZ",
  "tunisia": "TN", "egypt": "EG", "south-africa": "ZA", "turkey": "TR",
  "greece": "GR", "romania": "RO", "bulgaria": "BG", "hungary": "HU",
  "czech-republic": "CZ", "czechia": "CZ", "slovakia": "SK", "slovenia": "SI",
  "croatia": "HR", "serbia": "RS", "ukraine": "UA", "russia": "RU",
  "israel": "IL", "saudi-arabia": "SA", "united-arab-emirates": "AE",
  "iceland": "IS", "estonia": "EE", "latvia": "LV", "lithuania": "LT",
  "malta": "MT", "cyprus": "CY", "chile": "CL", "colombia": "CO", "peru": "PE",
  "guadeloupe": "GP", "martinique": "MQ", "reunion": "RE", "french-polynesia": "PF",
  "new-caledonia": "NC", "hong-kong": "HK", "taiwan": "TW", "pakistan": "PK",
};

const isoToFlag = (iso) =>
  String.fromCodePoint(...[...iso].map((c) => 0x1f1e6 + c.charCodeAt(0) - 65));

export const flagFor = (slug) => {
  if (slug === "world") return "🌍";
  if (slug === "european-union") return "🇪🇺";
  const iso = SLUG_TO_ISO[slug];
  return iso ? isoToFlag(iso) : "🌐";
};

export const prettyCountry = (slug) =>
  slug.split('-').map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
